<script>
  export default {
    name: 'channels-subscription'
  }
</script>

<template>
  <div></div>
</template>
